import React from "react";
import "./Headers.css";
import { useLanguage } from "../../../../LanguageProvider";
import { TbPlus } from "react-icons/tb";
import InputField from "../../../../components/InputField/InputField";

export default function Headers({ headers, setHeaders }) {
  const { getTranslation } = useLanguage();

  const headersArray = Array.isArray(headers) ? headers : [];

  const handleAddHeader = () => {
    setHeaders([
      ...headersArray,
      { key: "", value: "", description: "", selected: false },
    ]);
  };

  const handleDeleteHeader = (index) => {
    setHeaders(headersArray.filter((_, i) => i !== index));
  };

  const handleInputChange = (index, field, value) => {
    setHeaders(
      headersArray.map((header, i) =>
        i === index ? { ...header, [field]: value } : header
      )
    );
  };

  const handleCheckboxChange = (index) => {
    setHeaders(
      headersArray.map((header, i) =>
        i === index ? { ...header, selected: !header.selected } : header
      )
    );
  };

  return (
    <div className="api-headers-cointainer">
      <div className="api-headers-inner-cointainer">
        <button className="add-header-button" onClick={handleAddHeader}>
          {getTranslation("addHeader")} <TbPlus style={{}} />
        </button>

        <table style={{ width: "100%", marginTop: "15px" }}>
          <tbody>
            {headersArray?.length > 0 &&
              headersArray?.map((header, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="checkbox"
                      checked={header.selected || false}
                      onChange={() => handleCheckboxChange(index)}
                    />
                  </td>
                  <td>
                    <InputField
                      placeholder={getTranslation("key")}
                      value={header.key}
                      onChange={(e) =>
                        handleInputChange(index, "key", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <InputField
                      placeholder={getTranslation("value")}
                      value={header.value}
                      onChange={(e) =>
                        handleInputChange(index, "value", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <InputField
                      placeholder={getTranslation("description")}
                      value={header.description}
                      onChange={(e) =>
                        handleInputChange(index, "description", e.target.value)
                      }
                    />
                  </td>
                  <td
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <button
                      className="delete-header-button"
                      onClick={() => handleDeleteHeader(index)}
                    >
                      {getTranslation("delete")}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
